export default __webpack_public_path__ + "static/media/hotel_kv_jp_11.e66dbb46.jpg";